module.exports = __webpack_public_path__ + "static/media/25587159_1703510829724101_1000328822064732412_o.84482731.jpg";